<template>
	<div class="imgText">
		<div class="warp">
			<div class="banner">
				<img src="../static/8.png" alt="">
			</div>
			<!-- <p class="title">
				<span>王侯威仪</span>
				<em></em>
			</p>
			<div class="line"></div>
			<div style="overflow: scroll;padding-left:20px;">
				<ul class="tab-tilte">
			    	<li v-for="(title,index) in tabTitle" @click="tabdata(index)" :class="{active:cur==index}">{{title}}</li>
				</ul>
			</div> -->
			<div class="tab-content">
			  <div v-for="(m,index) in curdata">
			  		<dl v-for="item in m">
			  			<router-link tag="a" :to="{path:'detai',query:{id:item.id}}">
			  				<dt>
			  					<img :src="item.img" alt="">
			  				</dt>
			  			</router-link>
			  			<dd>{{item.title}}</dd>
			  		</dl>
			  </div>
			</div>
		</div>
		<div class="goback" @click="goback"></div>
	</div>
</template>
<script type="text/javascript">
	export default {
		data(){
			return{
				isActive:false,
				msg:'展开',
				tabTitle: ['礼乐宴飨', '车马出行','生活风尚','酎金积贮'],
				curdata:'',
				allData:{
					"data0":{
						data:[{
							id:1,
							img:require('../static/1_1.png'),
							title:'赫拉雕像',
							etitle:'Marble Statue of Hera',
							time:'公元前5世纪末期',
							etime:'Last decades of the V century BC',
							material:'大理石',
							ematerial:'Marble',
							dimensional:'高56厘米；长24厘米；厚24厘米；重64000克',
							edimensional:'Height 56cm;Length	24cm; Thickness 24cm；Weight 64000g',
							fromN:'赛莱河口的赫拉神庙',
							efromN:'HERAION DI FOCE SELE',
							fromN1:'意大利帕埃斯图姆考古遗址公园',
							efromN1:'Archaeological Park of Paestum',
							info:'<p>王座上的赫拉雕像。赫拉坐在一个高椅背、无扶手的方形宝座中，脚踩长方形基座。她内穿古希腊希顿长袍，领口在胸前垂坠成三角形褶绉；外套一件宽松长衫，右胸隐约微敞。女神面部为下颌突出的方形脸庞，头戴圆柱形高冠，长发散披于肩，唯额发编起。赫拉随意搭在腿上的右手中拿着一个希腊圆盘，左手则握着一颗石榴。</p><p>作为处于统治地位的女性形象以及家庭财富的守护者，赫拉雕像对应的是古希腊的“女性世界”。</p>'
						},{
							id:2,
							img:require('../static/1_2.png'),
							title:'城邦会堂石碑',
							etitle:'Stele of Ekklesiasterion',
							time:'公元前 4 世纪末期',
							etime:'Last decades of the IV century BC Limestone',
							material:'石灰石',
							ematerial:'Ekklesiasterion',
							dimensional:'高 115 厘米，长 36 厘米，厚 21 厘米,重 200，000 克',
							edimensional:'H 115 cm, L 36 cm, T 21 cm,Weight 200,000 g',
							info:'<p>石碑各面均覆有白色石膏，顶端的长方体通过类似钟形圆饰的结构与石碑主体相连。碑上有两条水平凹槽，顶端平面有用来固定小型青铜像的固定夹痕，青铜像现已遗失。</p><p>石 碑 的 四 面 有 希 腊 语 撰 写 的 红字 碑 文“Statis ... ies agiove ... anare built”(?)；这段碑文是卢卡尼亚的塞特提斯·塞特提里斯为宙斯撰写的，他可能是当时城中一位受人尊敬的法官。</p>'	
						},{
							id:3,
							img:require('../static/1_3.png'),
							title:'头戴花饰的女性陶塑',
							etitle:'Terracotta Bust of Flower-Woman',
							time:'公元前 4 世纪',
							etime:'IV century BC',
							material:'红陶',
							ematerial:'Terracotta',
							dimensional:'高 19 厘米，长 10.5 厘米，厚 9.5 厘米重 665 克',
							edimensional:'H 19 cm, L 10.5 cm, T 9.5 cm Weight 665 g',
							fromN:'赛莱河口的赫拉神庙',
							efromN:'Heraion Di Foce Sele',
							info:'<p>头戴花饰的女性半身陶制胸像。胸像小巧，外部覆盖的泛白陶泥浆改变了陶土的颜色；略粗糙的表面呈现出零散的黑色痕迹可能是焚香造成的。</p><p>这位女性有椭圆形的长脸，三角形额头，杏眼，眼窝深陷，鼻子圆润而挺 拔 。她的脖子上戴着一条项链，头发披散到双肩。优雅而复杂的冠状头饰构成发式的一部分，并固定住头纱。头纱覆盖整个头部，披散下来，露出女子的脸部和肩部。她头顶花饰的茎部和花萼较大，顶部突出的花冠为五瓣，花瓣中央有凹槽。</p>'		
						},{
							id:4,
							img:require('../static/1_4.png'),
							title:'日晷',
							etitle:'Marble Sundial',
							time:'罗马时代',
							etime:'Roman Period',
							material:'大理石',
							ematerial:'Marble',
							dimensional:'高 51 厘米，长 49 厘米，厚 30 厘米重 85，000 克',
							edimensional:'H 51 cm, L 49 cm, T 30 cm Weight 85,000 g',
							fromN:'南部圣所',
							efromN:'Santuario Meridionale',
							info:'<p>这是帕埃斯图姆出土的唯一一件日晷，属于罗马制式。日晷是利用太阳投射的影子来测定时刻的装置。它的残损令人感到极为痛心。日晷为球面型，七条小时线尚存，其中一条残损严重；其上标出至日线和赤道线，对于在一年中不同的时刻读取时间十分必要。刻度盘上小时之间的空间以衣褶的形式呈现；下方的球状构件或许代表地球。日晷两侧原有两个大型动物装饰，用于放置晷针的部分已经遗失。</p>'		
						},{
							id:5,
							img:require('../static/1_5.png'),
							title:'狮头造型滴水槽',	
							etitle:'Dripstone with Lion"s Head',
							time:'公元前 6 世纪末期',
							etime:'Last decades of the VI century BC Sandstone',
							material:'砂岩',
							//ematerial:'Marble',
							dimensional:'高 41 厘米，长 72 厘米，厚 39 厘米重 60，000 克（每件）',
							edimensional:'H 41 cm, L 72 cm, T 39 cm Weight 60,000 g (each)',
							fromN:'北部圣所',
							efromN:'Santuario Settentrionale',
							info:'<p>这组狮头造型滴水槽上的狮头鬃毛浓密，张嘴吐舌。滴水槽上还雕刻有一些其他装饰纹样。水滴槽由多个并排的元素组成。</p>'		
						},{
							id:6,
							img:require('../static/1_6.png'),
							title:'蛇发女妖瓦檐饰',
							etitle:'Antefix with Gorgon"s Head',
							time:'公元前 6 世纪',
							etime:'VI century BC',
							material:'红陶',
							ematerial:'Terracotta',
							dimensional:'高 16 厘米，长 20 厘米，厚 20 厘米重 2，420 克',
							edimensional:'H 16 cm, L 20 cm, T 20 cm Weight 2,420 g',
							fromN:'南部圣所',
							efromN:'Santuario Meridionale',
							info:'<p>陶制瓦檐饰，蛇发女妖。蛇发女妖圆脸，两颊丰满，杏眼圆睁。她的前额有四排蜗壳式的卷发，两侧为游蛇。女妖咧嘴龇牙，舌头吐出，下颌外突。</p>'		
						},{
							id:7,
							img:require('../static/1_7.jpg'),
							title:'持圆形盾牌的雅典娜雕像',
							etitle:'Fictile Figurine of Athena with a Rounded Shield',
							time:'公元前4世纪',
							etime:'IV century BC',
							material:'红陶',
							ematerial:'Terracotta',
							dimensional:'高 21.5 厘米，长 9.4 厘米，厚 7.5 厘米重 395 克',
							edimensional:'H 21.5 cm, L 9.4 cm, T 7.5 cm Weight 395 g',
							fromN:'北部圣所 - 刻瑞斯神庙',
							efromN:'Santuario Settentrionale - Tempio Di Cerere',
							info:'<p>尺寸较小的红陶制雅典娜雕像。雅典娜身着希顿长袍，系腰带。她头戴战盔，左手把扶着一枚靠在地上的圆形盾牌；右臂叉腰，右腿前屈。</p>'		
						}]
					}	
				},
				cur: 0 //默认选中第一个tab
			}
		},
		mounted(){
			this.curdata=this.allData['data0'];
			//console.log(this.curdata,589)
		},
		methods:{
			slidUp(){
				this.isActive=!this.isActive;
				if (this.isActive) {
					this.msg='收起'
				}else{
					this.msg='展开'
				}
			},
			tabdata(index){
				this.cur=index;
				var code='data'+index;
				this.curdata=this.allData[code];
				//console.log(this.curdata,456)
			},
			goback(){
				this.$router.go(-1)
			}
		}
	}
</script>
<style scoped>
	.goback{
		width: 0.62rem;
		height: 0.62rem;
		background:url(../static/g.png);
		background-size: 100% 100%;
		border-radius:100%;
		position: fixed;
		right: 20px;
		top: 60%;
	}
	.line{
		width:1rem;
		height: 1px;
		background:#ececec;
		margin: 0 auto;
		margin-bottom: .3rem;
	}
	.warp{
		width: 90%;
		margin: 0 auto;
		background:#fff;
		box-shadow: 0px 1px 15px #ededed;
		margin-top: 20px;
		border-radius:20px;
		padding-bottom:1rem;
		margin-bottom: 1rem;
	}
	.banner{
		width: 100%;
		border-top-left-radius:20px;
		border-top-right-radius:20px;
		margin-bottom: 0.4rem;
	}
	.banner img{
		width: 100%;
		border-top-left-radius:20px;
		border-top-right-radius:20px;
	}
	.title{
		width: 100%;
		text-align: left;
		font-size:20px;
		position: relative;
		margin-bottom: .8rem;
	}
	.title span{
		text-indent:0.14rem;
		letter-spacing: 3px;
		display: inline-block;
		z-index: 3;
		position: absolute;
	}
	.title em{
		display: inline-block;
		width: 0.85rem;
		height:9px;
		background: #e6bb70;
		left: 0.20rem;
		position: absolute;
		z-index: 1;
		top:10px;
	}
	.cont{
		width: 90%;
		margin: 0 auto;
	}
	.cont p{
		font-size: 16px;
		color:#666666;
		line-height: 30px;
		text-align: justify;
		margin-bottom: .10rem;
	}
	.cont dl{
		width: 100%;
		margin-bottom:.10rem;
	}
	.cont dl dt img{
		width: 100%;
	}
	.cont dl dd{
		font-size:14px;
		color:#adadad;
		margin-top: 0.15rem;
		line-height: 20px;
	}
	.butn{
		background:url(../static/bj1.png);
		height:.4rem;
		background-size: 100%;
		margin-top:.25rem;
		position: relative;
	}
	.btnC{
		width: 0.45rem;
		height: 0.23rem;
		border-radius: 50px;
		background:#fff;
		box-shadow: 0px 1px 15px #ededed;
		text-align: center;
		line-height: 0.23rem;
		margin: 0 auto;
		margin-top: -0.11rem;
		position: absolute;
		left: 50%;
		margin-left: -0.25rem;
		color:#e6bb70;
	}
	.activeClass{
		height: 2rem;
		overflow:hidden;
	}
	.hideClass{
		height: auto;
	}
	.tab-tilte{
	    width:1500px;
	}
	.tab-tilte li{
	    float: left;
	    width:1rem;
	    padding: 10px 0;
	    text-align: center;
	    cursor: pointer;
	    color:#cdcdcd;
	    font-size: 18px;
	    font-weight: bolder;
	}
	/* 点击对应的标题添加对应的背景颜色 */
	.tab-tilte .active{
	    color: #e6bb70;
	}
	.tab-content div{
	    width:95%;
	  	margin-top:.2rem;
	  	column-count:2;
	}		
	.tab-content div dl{
		background:#f5f5f5;
		border-radius: 4px;
		margin-left: 22px;
		padding-bottom: 30px;
		background: #fff;
		display: inline-block;
	}
	.tab-content div dl dt{
		justify-content: center;
		align-items: center;
	}
	.tab-content div dl dt img{
		max-width:100%;
		max-height: 100%;
		border-radius: 4px 4px 0 0;
	}
	.tab-content div dl dd{
		height: .3rem;
		background:#fff;
		line-height: .3rem;
		text-align: center;
		border-bottom-right-radius:4px;
		border-bottom-left-radius:4px;
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
		padding:0 5px; 
		box-shadow: 0px 1px 15px #d7d7d7;
	}
</style>